import script from "./GalleryLightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryLightbox.vue?vue&type=script&setup=true&lang=js"

import "./GalleryLightbox.vue?vue&type=style&index=0&id=157dc90a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-157dc90a"]])

export default __exports__